import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
export const getNextClubName = (subscription) => {
    const flowContent = getComponentContentById(subscription.product.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.FLOW.ID);
    if (!flowContent || flowContent.__typename !== "ContentChunkContent") {
        return undefined;
    }
    return flowContent.chunks
        .flatMap((chunk) => chunk
        .filter(({ componentId }) => componentId ===
        CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.FLOW.NEXT_CLUB)
        .map(({ content }) => {
        if (!content || content.__typename !== "ItemRelationsContent") {
            return undefined;
        }
        const name = content.items?.[0]?.name ?? content.productVariants?.[0]?.name;
        if (!name) {
            return undefined;
        }
        return name.trim();
    }))
        .find((name) => Boolean(name));
};
